<template>
  <div>
    <span class="v-toolbar__content v-toolbar__title subheading" style="height: 64px;">SCORM Settings</span>
    <div class="scorm-info">
      <h3>🧠 What is suspend_data in SCORM?</h3>
      <p class="scorm-p">
        <b>Suspend Data</b> stores custom information (like progress or choices) so a learner can resume later. Its maximum size is
        64 KB—going beyond that may cause data loss.
      </p>
      <h3>
        📊 Progress Bar Indicator
      </h3>
      <p class="scorm-p">
        The progress bar below gives a rough estimate of how much space your Interactive Presentation might use. It’s just a
        guide to help stay within limits.
      </p>
      <v-progress-linear :value="suspendDataPercentage" :color="getSuspendDataProgressColor(suspendDataPercentage)">
      </v-progress-linear>
      <span class="text--secondary">
        {{ Math.round(suspendDataSizeInBytes / 1000) }} kB / 64 kB used
      </span>
    </div>
  </div>
</template>

<script>
import { compress } from './compressState'
const MAX_DATA_SIZE = 65536
export default {
  name: "ScormPayloadInfo",
  inject: ["lessonPlanController"],
  components: {},
  data() {
    return {
      suspendDataSizeInBytes: 0,
      suspendDataPercentage: 0
    }
  },
  created() {
    this.calculateActivityState()
  },
  methods: {
    getSuspendDataProgressColor(percentage) {
      if (percentage > 75) return 'error'
      if (percentage > 50) return 'warning'
      return 'success'
    },
    calculateActivityState() {
      this.lessonPlanController.initActivityState()
    }
  },
  watch: {
    "lessonPlanController.activityState": {
      handler() {
        this.lessonPlanController.compressedActivityState = compress(this.lessonPlanController.activityState)
        this.suspendDataSizeInBytes = this.lessonPlanController.compressedActivityState.length
        this.suspendDataPercentage = (this.suspendDataSizeInBytes / MAX_DATA_SIZE) * 100

        if (this.suspendDataPercentage > 100) this.suspendDataPercentage = 100
      }
    }
  }
}
</script>
<style lang="css" scoped>
.scorm-info {
  margin: 0px 24px;
}

.scorm-p {
  margin-bottom: 16px;
}
</style>